module.exports = __webpack_public_path__ + "static/media/blue-drop.a6a0c757.svg";